module.exports = __webpack_public_path__ + "assets/img/station15.93a1e145.png";